import ace from 'brace'

ace.define('ace/mode/turtle', ['require', 'exports', 'module', 'ace/lib/oop', 'ace/mode/text', 'ace/mode/text_highlight_rules'], function(acequire, exports) {
  const oop = acequire('../lib/oop')
  const TextMode = acequire('./text').Mode
  const TextHighlightRules = acequire('./text_highlight_rules').TextHighlightRules

  const TurtleHighlightRules = function() {
    this.$rules = {
      start: [
        {
          token: 'comment',
          regex: /#.*/
        },
        {
          token: 'keyword',
          regex: /@prefix|@base|@keywords|a\b|true|false/
        },
        {
          token: 'constant.language',
          regex: /(?:PREFIX|BASE|SELECT|CONSTRUCT|WHERE|FILTER|OPTIONAL|UNION|GRAPH)\b/
        },
        {
          token: 'string.uri',
          regex: /<[^>]*>/
        },
        {
          token: 'string.quoted',
          regex: /"""(?:[^"\\]|\\.)*"""|'''(?:[^'\\]|\\.)*'''|"(?:[^"\\]|\\.)*"|'(?:[^'\\]|\\.)*'/
        },
        {
          token: 'constant.numeric',
          regex: /[+-]?\d+(?:\.\d+)?(?:[eE][+-]?\d+)?/
        },
        {
          token: 'variable.language',
          regex: /\?[a-zA-Z_][a-zA-Z0-9_-]*/
        },
        {
          token: 'entity.name.tag',
          regex: /[a-zA-Z_][a-zA-Z0-9_-]*:[a-zA-Z_][a-zA-Z0-9_-]*/
        },
        {
          token: 'keyword.operator',
          regex: /\.|;|,|\[|\]|\(|\)|\^\^|@[a-z]{2}(?:-[a-z]{2})?/
        },
        {
          token: 'text',
          regex: /\s+/
        }
      ]
    }
  }

  oop.inherits(TurtleHighlightRules, TextHighlightRules)

  const Mode = function() {
    this.HighlightRules = TurtleHighlightRules
  }
  oop.inherits(Mode, TextMode)

  ;(function() {
    this.$id = 'ace/mode/turtle'
  }).call(Mode.prototype)

  exports.Mode = Mode
})
